import cn from 'classnames';
import styles from './styles.scss';
import { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}
export const Item = ({ children, className, ...props }: Props) => (
  <div className={cn(styles.item, className)} {...props}>
    {children}
  </div>
);
